import { BarItemProps } from "@nivo/bar";
import {
    CORPORATE_MC_POPOVER_ID,
    CORPORATE_SECONDARY_MC_POPOVER_ID,
    DefaultTranslationFieldsInTable,
    SummaryOption,
} from "constants/constants";
import { CorporateDashboardContext } from "contexts/CorporateDashboardContext/CorporateDashboardContext";
import { FC, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { translateDefaultEntity } from "utilities/localesUtilities";

const CorporateMillBarComponent: FC<BarItemProps<{ [key: string]: string | number }>> = (props) => {
    const {
        selectedMillPopoverData,
        handleSetSelectedMillPopoverData,
        selectedFailureCode,
        selectedSecondaryFailureCode,
    } = useContext(CorporateDashboardContext);
    const { t, i18n } = useTranslation();

    const summaryOption = props.bar.data.data.summaryOption as SummaryOption;

    const openPopoverId = useMemo(() => {
        if (!selectedMillPopoverData) return undefined;
        return summaryOption === SummaryOption.BY_SECONDARY_CODE
            ? CORPORATE_SECONDARY_MC_POPOVER_ID
            : CORPORATE_MC_POPOVER_ID;
    }, [selectedMillPopoverData, summaryOption]);

    const handleClick = (event: React.MouseEvent<SVGGElement, MouseEvent>) => {
        const millId = Number(props.bar.data.data.millId);
        const millName = String(props.bar.data.data.mill);

        const failureCodeName =
            translateDefaultEntity(
                i18n.language,
                selectedFailureCode,
                "name",
                DefaultTranslationFieldsInTable.FAILURE_CODE,
            ) || "";

        const secondaryFailureCodeName =
            translateDefaultEntity(
                i18n.language,
                selectedSecondaryFailureCode,
                "name",
                DefaultTranslationFieldsInTable.FAILURE_CODE,
            ) || "";

        const title =
            summaryOption === SummaryOption.BY_SECONDARY_CODE
                ? t("corporate_dashboard.downtime_by_secondary_failure_codes_by_mill.title_modal", {
                      secondaryFailureCode: secondaryFailureCodeName,
                      mill: millName,
                  })
                : t("corporate_dashboard.downtime_by_failure_code_by_mill.title_modal", {
                      failureCode: failureCodeName,
                      mill: millName,
                  });

        handleSetSelectedMillPopoverData({
            millId,
            millName,
            barElement: event.currentTarget,
            summaryOption,
            title,
        });
    };

    return (
        <g
            aria-describedby={openPopoverId}
            transform={`translate(${props.bar.x}, ${props.bar.y})`}
            onClick={handleClick}
        >
            <rect width={props.bar.width} height={props.bar.height} fill={props.bar.color} />
        </g>
    );
};

export default CorporateMillBarComponent;
